<template>
    <div class="flex-container my-4">
        <div class="flex gap-2">
            <div class="flex items-center">
                <Icone :nome="'mail'" />
                <label for="emailEnvioChecklist">
                    {{ descricao }}
                    <span v-if="respostaObrigatoria == true" class="text-xs text-vermelho-padrao">*</span>
                </label>
            </div>
            <Status v-if="!idComponentePai" />
        </div>
        <div v-if="!resumo" class="mt-2">
            <input type="email" class="input-padrao" :class="error ? 'error' : ''" name="emailEnvioChecklist"
                id="emailEnvioChecklist" placeholder="Informe um email para envio do checklist" v-model="emailInformado"
                @change="salvarEmailInformado">
        </div>
        <p v-else><span class="font-semibold">Email:</span> {{ emailInformado ?? '-' }}</p>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import PropsComponentesConstant from '@/constants/PropsComponentesConstant';
import Icone from '@/components/Icone.vue';
import Status from '@/components/Status.vue';
import ComponenteEmailService from '@/services/componentes/ComponenteEmailService'
import ComponentesService from '@/services/ComponentesService'
import FuncoesHelper from '@/helpers/FuncoesHelper'

export default defineComponent({
    name: 'Email',
    components: {
        Icone,
        Status
    },
    props: {
        ...PropsComponentesConstant.PROPS,
    },
    methods: {
        salvarEmailInformado() {
            if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.emailInformado))) {
                FuncoesHelper.notificar('error', 'Atenção', 'Informe um email válido');
                this.error = true
                this.emailInformado = ''
                this.salvarEstado()
                return;
            }
            this.error = false
            this.salvarEstado()
        },
        salvarEstado() {
            ComponentesService.salvarRespostaEstadoComponente(this.modulo, this.etapaComponente, this.identificador, this.emailInformado, this.idComponentePai)
        }
    },
    setup(props) {
        return ComponenteEmailService.setup(props)
    }
});
</script>

<style scoped>
.error {
    @apply border-b-2 border-vermelho-padrao focus:border-vermelho-padrao hover:border-vermelho-padrao;
}
</style>